import { useAppSelector } from "../../redux/hooks.ts";
import {
  generalRequirementHeaderDocument,
  generalRequirementHeaderForm,
} from "./fixtures/generalRequirementHeader.tsx";
import { GeneralForm } from "./forms/GeneralForm.tsx";
import { GeneralDocument } from "./GeneralDocument.tsx";

interface Props {
  onRegisterSubmit?: (submitFn: (() => Promise<boolean>) | null) => void;
}

export const GeneralRequirement: React.FC<Props> = ({ onRegisterSubmit }) => {
  const { activeRequirement } = useAppSelector((state) => state.vault);

  return (
    <div>
      {activeRequirement?.type === "form" ? (
        <GeneralForm header={generalRequirementHeaderForm} onRegisterSubmit={onRegisterSubmit} />
      ) : (
        <GeneralDocument header={generalRequirementHeaderDocument} onRegisterSubmit={onRegisterSubmit} />
      )}
    </div>
  );
};
